import { forwardRef } from "react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

const AuthInput = forwardRef(({ className, icon: Icon, ...props }, ref) => {
  const input = (
    <Input
      ref={ref}
      className={cn(
        "h-12 min-w-0 rounded-xl border border-primary/45 bg-muted px-3 font-medium shadow-none transition-colors duration-200 placeholder:text-muted-foreground/70 focus-visible:border-primary/45 focus-visible:bg-muted focus-visible:ring-0 focus-visible:ring-offset-0",
        Icon && "pl-12",
        className
      )}
      {...props}
    />
  );

  if (!Icon) {
    return input;
  }

  return (
    <div className="group relative min-w-0 w-full flex-1">
      <div className="pointer-events-none absolute inset-y-0 left-2.5 z-10 flex items-center">
        <span className="flex h-7 w-7 items-center justify-center rounded-lg border border-primary/10 bg-primary/[0.07] text-primary transition-colors group-focus-within:border-primary/20 group-focus-within:bg-primary/10">
          <Icon className="h-3.5 w-3.5" />
        </span>
      </div>
      {input}
    </div>
  );
});

AuthInput.displayName = "AuthInput";

export default AuthInput;
